import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

/**
 * Per-line item note entered by the client at cart checkout (visible to client and host).
 */
export default function OrderItemClientNote({ item, sx }) {
  const { t } = useTranslation();
  const note = item?.clientItemNote != null ? String(item.clientItemNote).trim() : '';
  if (!note) return null;
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      display="block"
      sx={{ fontStyle: 'italic', ...sx }}
    >
      {t('orders.itemClientNote')}: {note}
    </Typography>
  );
}
